import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { registerPlotType } from '../../base/global';
import GaugeLayer from '../gauge/layer';
import { getOptions } from '../gauge/geometry/shape/options';
import { getGlobalTheme } from '../../theme';
var MeterGaugeLayer = /** @class */ (function (_super) {
    __extends(MeterGaugeLayer, _super);
    function MeterGaugeLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'meterGauge';
        return _this;
    }
    MeterGaugeLayer.getDefaultOptions = function () {
        return deepMix({}, _super.getDefaultOptions.call(this), {});
    };
    MeterGaugeLayer.prototype.getCustomStyle = function () {
        var _a = this.options, theme = _a.theme, styleMix = _a.styleMix;
        var colors = styleMix.colors || getGlobalTheme().colors;
        return getOptions('meter', theme, colors);
    };
    return MeterGaugeLayer;
}(GaugeLayer));
export default MeterGaugeLayer;
registerPlotType('meterGauge', MeterGaugeLayer);
//# sourceMappingURL=layer.js.map